import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        question: '=',
        form: '=',
        isTrial: '=',
        selectedLanguage: '=',
        showCorrectAnswers: '=',
        showAnswerFeedback: '=',
        showTesteesAnswers: '=',
        formSubmission: '=',
        showPointsAwarded: '='
    },
    template: `
        <div class="alert alert-danger" ng-if="vm.form.answers[vm.question.id].errors.answerId">{{ vm.form.answers[vm.question.id].errors.answerId }}</div>
        <div class="heading01">
            <div class="question-title" ng-bind-html="vm.getQuestionName() | isRequired: vm.question.formQuestions[0].isRequired"></div>
            <ul class="metablock" ng-if="vm.showPointsAwarded">
                <li>
                    <div class="label">{{ 'quiz.Points awarded' | translate }}</div>
                    <div class="value">{{ vm.getPointsObtained() }} / {{ vm.question.score }}</div>
                </li>
            </ul>
        </div>
        <ul class="items10">
            <li ng-if="vm.question.imageFilename" ng-style="{ 'background-image': 'url('+vm.QuestionService.getImageUrl(vm.question, 'small')+')' }">
                <a class="overlay" ng-click="vm.openImageModal(vm.question)">{{ 'general.Zoom in' | translate }}</a>
            </li>
        </ul>
        <div ng-if="vm.question.videoUrl" class="quiz-video">
            <embed-video width="560" height="315" ng-href="{{ vm.question.videoUrl }}" controls=1></embed-video>
        </div>
        <div ng-if="vm.question.videoFilename" class="quiz-video">
            <video width="560" height="315" controls>
                <source ng-src="{{ vm.QuestionService.getVideoUrl(vm.question) }}">
            </video>
        </div>
        <ul class="checkboxes">
            <li ng-repeat="answer in vm.question.questionAnswers"
                ng-class="{
                    status01: (vm.showCorrectAnswers && answer.isCorrectAnswer)
                    || (vm.showTesteesAnswers && answer.isCorrectAnswer && (vm.form.answers[vm.getAnswerIndex(answer.id)].answerId) === answer.id),
                    status02: (vm.showCorrectAnswers && !answer.isCorrectAnswer)
                    || (vm.showTesteesAnswers && !answer.isCorrectAnswer && (vm.form.answers[vm.getAnswerIndex(answer.id)].answerId) === answer.id)
                }">
                <label><input
                    type="checkbox"
                    ng-disabled="vm.showCorrectAnswers || vm.showAnswerFeedback || vm.showTesteesAnswers || vm.showPointsAwarded"
                    ng-checked="vm.hasAnswer(answer.id)"
                    ng-click="vm.toggleAnswer(answer.id)"
                    ng-value="answer.id" name="question-{{ vm.question.id }}-{{ answer.id }}"
                ><span>{{ vm.getAnswerText(answer) }}</span></label>
                <ul class="items10">
                    <li
                        ng-style="{ 'background-image': 'url('+vm.QuestionService.getAnswerImageUrl(answer, vm.question.companyId, 'small')+')' }"
                        ng-if="answer.imageFilename"
                    >
                        <a class="overlay" ng-click="vm.openAnswerImageModal(answer, vm.question.companyId)">{{ 'general.Zoom in' | translate }}</a>
                    </li>
                </ul>
                <div ng-if="answer.videoUrl" class="quiz-video">
                    <embed-video width="560" height="315" ng-href="{{ answer.videoUrl }}" controls=1></embed-video>
                </div>
                <div ng-if="answer.videoFilename" class="quiz-video">
                    <video width="560" height="315" controls>
                        <source ng-src="{{ vm.QuestionService.getAnswerVideoUrl(answer, vm.question.companyId) }}">
                    </video>
                </div>
                <div ng-if="vm.showAnswerFeedback && answer.feedback && vm.hasAnswer(answer.id)" class="answer-feedback">
                    <h4>{{ 'quiz.Answer feedback' | translate }}</h4>
                    <div ng-bind-html="answer.feedback"></div>
                </div>
            </li>
        </ul>
    `
})
export default class {
    constructor (lodash, TokenService, QuestionService, QUESTIONS_TYPE_ENUM) {
        this.lodash = lodash;
        this.TokenService = TokenService;
        this.QuestionService = QuestionService;
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
    }

    $onInit () {
        this.defaultLanguage = this.TokenService.getCompanyLanguage();

        if (this.isTrial && this.question.questionAnswers) {
            this.mapAnswerTranslations();
        }

        this.isAnswered = this.question.submittedAnswers && this.question.submittedAnswers.length;

        if (this.isAnswered) {
            this.answeredQuestions = this.answeredQuestions + 1;
            this.question.submittedAnswers.forEach((submittedAnswer) => {
                let index = this.question.id;

                if (submittedAnswer.answerId) {
                    index = `${this.question.id}${submittedAnswer.answerId}`;
                }
                this.form.answers[index] = this.getAnswer(submittedAnswer.answerId, submittedAnswer.id);
            });
        }
        else {
            this.form.answers[this.question.id] = this.getAnswer();
        }
    }

    getPointsObtained () {
        if (this.question.type === this.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX && !this.question.isPartialPoints) {
            // if all answers are correct - return question max points, otherwise - 0 points.
            let isCorrect = true;

            this.lodash.forEach(this.question.questionAnswers, questionAnswer => {
                if (questionAnswer.isCorrectAnswer && !this.isAnwserSelected(this.question.id, questionAnswer)) {
                    isCorrect = false;
                }
                if (!questionAnswer.isCorrectAnswer && this.isAnwserSelected(this.question.id, questionAnswer)) {
                    isCorrect = false;
                }
            });

            return isCorrect ? this.question.points : 0;
        }

        let points = 0;
        this.lodash.forEach(this.formSubmission.formSubmissionAnswers, fsAnswer => {
            if (fsAnswer.questionId === this.question.id) {
                points += fsAnswer.points;
            }
        });

        if (points < 0) {
            points = 0;
        }

        return points;
    }

    isAnwserSelected (questionId, answer) {
        let isAnswered = false;
        this.lodash.forEach(this.formSubmission.formSubmissionAnswers, fsAnswer => {
            if (fsAnswer.question.id === questionId && fsAnswer.answerId === answer.id) {
                isAnswered = true;
            }
        });

        return isAnswered;
    }

    hasAnswer (answerId) {
        return this.lodash.find(this.form.answers, { questionId: this.question.id, answerId }) !== undefined;
    }

    getQuestionName () {
        if (this.isTrial) {
            return this.question.questionI18ns[this.selectedLanguage] ?
                this.question.questionI18ns[this.selectedLanguage].name :
                this.question.questionI18ns[this.defaultLanguage].name;
        }

        return this.question.activeI18n.name;
    }

    toggleAnswer (answerId) {
        const index = `${this.question.id}${answerId}`;
        if (this.hasAnswer(answerId)) {
            delete this.form.answers[index];
        }
        else {
            const submittedAnswer = this.lodash.find(this.question.submittedAnswers, { answerId });
            const submittedAnswerId = submittedAnswer ? submittedAnswer.id : null;
            this.form.answers[index] = this.getAnswer(answerId, submittedAnswerId);
        }
        this.updateAnsweredQuestions();
    }

    /**
     * This function removes empty answer from question
     */
    removeEmptyAnswer () {
        if (this.form.answers[this.question.id]) {
            delete this.form.answers[this.question.id];
        }
    }

    /**
     * This function adds empty answer to question, used to trigger validation
     */
    addEmptyAnswer () {
        if (!this.form.answers[this.question.id]) {
            this.form.answers[this.question.id] = this.getAnswer();
        }
    }

    getAnswer (answerId = null, submittedAnswerId = null) {
        return {
            id: submittedAnswerId,
            questionId: this.question.id,
            language: 'et',
            answerId
        };
    }

    getAnswerIndex (answerId) {
        const index = `${this.question.id}${answerId}`;
        return index;
    }

    mapAnswerTranslations () {
        this.answerTranslations = {};
        this.lodash.forEach(this.question.questionAnswers, (answer) => {
            this.answerTranslations[answer.id] = this.lodash.reduce(this.question.questionAnswersI18ns, (origin, answerI18n) => {
                if (answerI18n.answerId === answer.id) {
                    if (!origin[answerI18n.language]) {
                        origin[answerI18n.language] = {};
                    }
                    origin[answerI18n.language] = answerI18n;
                }
                return origin;
            }, {});
        });
    }

    getAnswerText (answer) {
        if (this.isTrial) {
            return this.answerTranslations[answer.id][this.selectedLanguage] ?
                this.answerTranslations[answer.id][this.selectedLanguage].text :
                this.answerTranslations[answer.id][this.defaultLanguage].text
            ;
        }
        return answer.text;
    }

    updateAnsweredQuestions () {
        this.removeEmptyAnswer();
        const hasAnswer = this.lodash.find(this.form.answers, { questionId: this.question.id }) !== undefined;
        if (hasAnswer && !this.isAnswered) {
            this.answeredQuestions = this.answeredQuestions + 1;
            this.isAnswered = true;
        }
        else if (this.isAnswered && !hasAnswer) {
            this.answeredQuestions = this.answeredQuestions - 1;
            this.isAnswered = false;
        }

        if (!this.isAnswered) {
            this.addEmptyAnswer();
        }
    }

    openImageModal (question) {
        return this.QuestionService.openImageModal(question);
    }

    openAnswerImageModal (answer, companyId) {
        return this.QuestionService.openAnswerImageModal(answer, companyId);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/quiz/question/checkbox/index.js